/**
 * Right slide-out cart drawer (replaces fancybox add-to-cart popup).
 */
(function ($) {
  if (typeof Shopify === 'undefined') return;

  function escapeHtml(s) {
    if (s == null) return '';
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  /** Title case: first letter of each word uppercased, rest lowercased */
  function toTitleCase(str) {
    if (!str || typeof str !== 'string') return '';
    return str.replace(/\S+/g, function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });
  }

  function lineImageUrl(item) {
    if (item.image) return item.image;
    if (item.featured_image && item.featured_image.url) return item.featured_image.url;
    return '';
  }

  function updateSidebarCartCount(cart) {
    if (cart && typeof cart.item_count === 'number') {
      $('#cart_items').html(cart.item_count);
      var $badge = $('.header-mobile__cart-count');
      if (cart.item_count > 0) {
        if ($badge.length) {
          $badge.text(cart.item_count);
        } else {
          $('.header-mobile__icon--cart').append(
            '<span class="header-mobile__cart-count">' + cart.item_count + '</span>'
          );
        }
      } else {
        $badge.remove();
      }
    }
  }

  Shopify.closeCartDrawer = function () {
    $('body').removeClass('cart-drawer-open');
    $('#cart-drawer').attr('aria-hidden', 'true');
  };

  function fetchCartAndOpen() {
    $.getJSON('/cart.js', function (cart) {
      Shopify.openCartDrawer(cart);
    });
  }

  Shopify.openCartDrawer = function (cart) {
    if (typeof $.fancybox !== 'undefined') {
      try {
        $.fancybox.hideLoading();
        if ($.fancybox.helpers && $.fancybox.helpers.overlay) {
          $.fancybox.helpers.overlay.close();
        }
      } catch (e) {}
    }

    var $items = $('#cart-drawer-items');
    var $below = $('#cart-drawer-below');
    if (!$items.length) return;

    if (window.__shopMoneyFormat) {
      Shopify.money_format = window.__shopMoneyFormat;
    }

    if (!cart || !cart.items || cart.items.length === 0) {
      $items.html('<p class="cart-drawer__empty">Your cart is empty.</p>');
      if ($below.length) {
        $below.attr('hidden', true).hide();
      }
    } else {
      var html = '';
      cart.items.forEach(function (item, index) {
        var imgUrl = lineImageUrl(item);
        var title = toTitleCase(item.product_title || item.title || '');
        var variant = item.variant_title;
        if (variant === 'Default Title' || variant === 'Default') variant = '';
        var lineIndex = index + 1;
        var lineCents = item.final_line_price != null ? item.final_line_price : item.line_price;
        var priceStr = Shopify.formatMoney(lineCents);

        html += '<div class="cart-drawer__line" data-line-index="' + lineIndex + '">';
        if (imgUrl) {
          html +=
            '<div class="cart-drawer__line-img"><img src="' +
            escapeHtml(imgUrl) +
            '" alt="' +
            escapeHtml(title) +
            '"></div>';
        }
        html += '<div class="cart-drawer__line-main">';
        html += '<div class="cart-drawer__line-row">';
        html += '<span class="cart-drawer__line-title">' + escapeHtml(title) + '</span>';
        html += '<span class="cart-drawer__line-price">' + priceStr + '</span>';
        html += '</div>';
        if (variant) {
          html += '<div class="cart-drawer__line-variant">' + escapeHtml(variant) + '</div>';
        }
        html +=
          '<button type="button" class="cart-drawer__remove" data-line-index="' +
          lineIndex +
          '" aria-label="Remove">Remove</button>';
        html += '</div></div>';
      });
      $items.html(html);

      if ($below.length) {
        $('#cart-drawer-total').html(Shopify.formatMoney(cart.total_price));
        $below.removeAttr('hidden').show();
      }
    }

    updateSidebarCartCount(cart);

    $('body').addClass('cart-drawer-open');
    $('#cart-drawer').attr('aria-hidden', 'false');
  };

  $(document).on('click', '[data-cart-drawer-close]', function (e) {
    e.preventDefault();
    Shopify.closeCartDrawer();
  });

  $(document).on('click', 'a.js-open-cart-drawer', function (e) {
    e.preventDefault();
    fetchCartAndOpen();
  });

  $(document).on('click', '.cart-drawer__remove', function (e) {
    e.preventDefault();
    var line = parseInt($(this).attr('data-line-index'), 10);
    if (!line || line < 1) return;
    var $btn = $(this);
    $btn.prop('disabled', true);
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: { quantity: 0, line: line },
      dataType: 'json',
      success: function () {
        $.getJSON('/cart.js', function (cart) {
          Shopify.openCartDrawer(cart);
        });
      },
      error: function () {
        $btn.prop('disabled', false);
      }
    });
  });

  $(function () {
    var search = window.location.search || '';
    if (search.indexOf('shop_cart_open=1') === -1) return;
    fetchCartAndOpen();
    if (!history.replaceState) return;
    var q = (search.slice(1) || '').split('&').filter(function (p) {
      return p && p.indexOf('shop_cart_open=') !== 0;
    });
    var next = q.length ? '?' + q.join('&') : '';
    history.replaceState({}, '', window.location.pathname + next + window.location.hash);
  });

  $(document).on('keydown', function (e) {
    if (e.key === 'Escape' && $('body').hasClass('cart-drawer-open')) {
      Shopify.closeCartDrawer();
    }
  });
})(jQuery);
